import apiService from './apiService';

// أنواع البيانات للتقارير المالية
export interface TrialBalanceItem {
  accountId: string;
  accountNumber: string;
  accountName: string;
  accountCategory?: string;
  parentAccountName?: string | null;
  debit: number;
  credit: number;
  balance: number;
}

export interface TrialBalanceResponse {
  success: boolean;
  data: TrialBalanceItem[];
  totals: {
    totalDebit: number;
    totalCredit: number;
    difference: number;
  };
  period: {
    startDate: string;
    endDate: string;
  };
}

export interface IncomeStatementItem {
  accountId: string;
  accountNumber: string;
  accountName: string;
  amount: number;
}

export interface IncomeStatementResponse {
  success: boolean;
  data: {
    revenues: IncomeStatementItem[];
    expenses: IncomeStatementItem[];
  };
  totals: {
    totalRevenue: number;
    totalExpenses: number;
    netIncome: number;
  };
  period: {
    startDate: string;
    endDate: string;
  };
}

export interface BalanceSheetItem {
  accountId: string;
  accountNumber: string;
  accountName: string;
  amount: number;
}

export interface BalanceSheetResponse {
  success: boolean;
  data: {
    assets: BalanceSheetItem[];
    liabilities: BalanceSheetItem[];
    equity: BalanceSheetItem[];
  };
  totals: {
    totalAssets: number;
    totalLiabilities: number;
    totalEquity: number;
    totalLiabilitiesAndEquity: number;
  };
  asOfDate: string;
}

/**
 * الحصول على ميزان المراجعة
 */
export const getTrialBalance = async (
  startDate: string,
  endDate: string
): Promise<TrialBalanceResponse> => {
  try {
    const response = await apiService.get<TrialBalanceResponse>(
      '/finance/reports/trial-balance',
      {
        params: { startDate, endDate }
      }
    );
    return response;
  } catch (error) {
    console.error('خطأ في جلب ميزان المراجعة:', error);
    throw error;
  }
};

/**
 * الحصول على قائمة الدخل
 */
export const getIncomeStatement = async (
  startDate: string,
  endDate: string
): Promise<IncomeStatementResponse> => {
  try {
    const response = await apiService.get<IncomeStatementResponse>(
      '/finance/reports/income-statement',
      {
        params: { startDate, endDate }
      }
    );
    return response;
  } catch (error) {
    console.error('خطأ في جلب قائمة الدخل:', error);
    throw error;
  }
};

/**
 * الحصول على قائمة المركز المالي
 */
export const getBalanceSheet = async (
  endDate: string
): Promise<BalanceSheetResponse> => {
  try {
    const response = await apiService.get<BalanceSheetResponse>(
      '/finance/reports/balance-sheet',
      {
        params: { endDate }
      }
    );
    return response;
  } catch (error) {
    console.error('خطأ في جلب قائمة المركز المالي:', error);
    throw error;
  }
};